module.exports = __webpack_public_path__ + "static/homepage-mobile-foodapp-a18f131cd59b4ca1d893189d2662c772.jpg";